export class IssuesFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<IssueType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<IssueType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IssuesFilters.attributeTypeMap;
    }
    constructor() {
    }
}
